<template lang="pug">
  include ./../../vuek/mixins.pug

  +b.the-table-section
    t-section
      t-h2(white) {{content.header4}}
      t-h3 {{content.subHeader4}}

      +e.table
        +e.row._titles
          +e.rank
            +e.SPAN.vert Місце в рейтингу
          +e.name
            +e.SPAN.vert Країна
          +e.score
            +e.SPAN.vert Кількість балів
          +e.col
            +e.SPAN.vert PERC Asia Risk Guide
          +e.col
            +e.SPAN.vert World Bank CPIA
          +e.col
            +e.SPAN.vert World Economic Forum EOS
          +e.col
            +e.SPAN.vert Global Insight Country <br>Risk Ratings
          +e.col
            +e.SPAN.vert Bertelsmann Foundation <br>Transformation Index
          +e.col
            +e.SPAN.vert African Development Bank<br>CPIA
          +e.col
            +e.SPAN.vert IMD World Competitiveness<br>Yearbook
          +e.col
            +e.SPAN.vert Bertelsmann Foundation<br>Sustainable Governance Index
          +e.col
            +e.SPAN.vert World Justice Project<br>Rule of Law Index
          +e.col
            +e.SPAN.vert PRS International Country<br>Risk Guide
          +e.col
            +e.SPAN.vert Varieties of Democracy<br>Project
          +e.col
            +e.SPAN.vert Economist Intelligence<br>Unit Country Ratings
          +e.col
            +e.SPAN.vert Freedom House Nations<br>in Transit Ratings
        +e.row._first
          +e.rank
            t-sort(@click="handleSort(0)" :decrise="decrise[0]" :active="sorting == 0")
          +e.name
          +e.score
            t-sort(@click="handleSort(1)" :decrise="decrise[1]" :active="sorting == 1")
          +e.col
            t-sort(@click="handleSort(2)" :decrise="decrise[2]" :active="sorting == 2")
          +e.col
            t-sort(@click="handleSort(3)" :decrise="decrise[3]" :active="sorting == 3")
          +e.col
            t-sort(@click="handleSort(4)" :decrise="decrise[4]" :active="sorting == 4")
          +e.col
            t-sort(@click="handleSort(5)" :decrise="decrise[5]" :active="sorting == 5")
          +e.col
            t-sort(@click="handleSort(6)" :decrise="decrise[6]" :active="sorting == 6")
          +e.col
            t-sort(@click="handleSort(7)" :decrise="decrise[7]" :active="sorting == 7")
          +e.col
            t-sort(@click="handleSort(8)" :decrise="decrise[8]" :active="sorting == 8")
          +e.col
            t-sort(@click="handleSort(9)" :decrise="decrise[9]" :active="sorting == 9")
          +e.col
            t-sort(@click="handleSort(10)" :decrise="decrise[10]" :active="sorting == 10")
          +e.col
            t-sort(@click="handleSort(11)" :decrise="decrise[11]" :active="sorting == 11")
          +e.col
            t-sort(@click="handleSort(12)" :decrise="decrise[12]" :active="sorting == 12")
          +e.col
            t-sort(@click="handleSort(13)" :decrise="decrise[13]" :active="sorting == 13")
          +e.col
            t-sort(@click="handleSort(14)" :decrise="decrise[14]" :active="sorting == 14")
        +e.row(
          v-for="item in displayedData"
          :key="item.ISO3"
        )
          +e.rank
            | {{item.rank.y18}}
            +e.SUP.index(
              v-if="item.rank.y17 && (item.rank.y18 - item.rank.y17 !== 0)"
              :class="[item.rank.y17 - item.rank.y18 > 0 ? 'the-table-section__index_green' : 'the-table-section__index_red']"
            ) {{item.rank.y17 - item.rank.y18 > 0 ? '+' : ''}}{{item.rank.y17 - item.rank.y18}}
            +e.popup._right
              | {{content.rank}}
              template(v-if="item.rank.y18")
                br
                | 2018: {{item.rank.y18}}
              template(v-if="item.rank.y17")
                br
                | 2017: {{item.rank.y17}}
              template(v-if="item.rank.y16")
                br
                | 2016: {{item.rank.y16}}
          +e.name {{lng === 'ua' ? item.name_ua : item.country}}
          +e.score(
            v-bind:style="bgColor(item.CPIScore.y18 - item.CPIScore.y17)"
          )
            | {{item.CPIScore.y18}}
            +e.SUP.index(
              v-if="item.CPIScore.y17 && (item.CPIScore.y18 - item.CPIScore.y17 !== 0)"
              :class="[item.CPIScore.y18 - item.CPIScore.y17 > 0 ? 'the-table-section__index_green' : 'the-table-section__index_red']"
            ) {{item.CPIScore.y18 - item.CPIScore.y17 > 0 ? '+' : ''}}{{item.CPIScore.y18 - item.CPIScore.y17}}
            +e.popup._right
              | {{content.cpi}}
              template(v-if="item.CPIScore.y18")
                br
                | 2018: {{item.CPIScore.y18}}
              template(v-if="item.CPIScore.y17")
                br
                | 2017: {{item.CPIScore.y17}}
              template(v-if="item.CPIScore.y16")
                br
                | 2016: {{item.CPIScore.y16}}
          +e.col(
            v-for="(indicator, i) in item.indicators"
            :key="i"
            v-bind:style="bgColor(indicator.y18 && indicator.y17 ? indicator.y18 - indicator.y17 : null)"
          )
            | {{indicator.y18}}
            +e.SUP.index(
              v-if="indicator.y18 && indicator.y17 && (indicator.y18 - indicator.y17 !== 0)"
              :class="[indicator.y18 - indicator.y17 > 0 ? 'the-table-section__index_green' : 'the-table-section__index_red']"
            ) {{indicator.y18 - indicator.y17 > 0 ? '+' : ''}}{{indicator.y18 - indicator.y17}}
            +e.popup(:class="[i > 7 ? 'the-table-section__popup_left' : 'the-table-section__popup_right']")
              | {{indicator.name}}
              template(v-if="indicator.y18")
                br
                | 2018: {{indicator.y18}}
              template(v-if="indicator.y17")
                br
                | 2017: {{indicator.y17}}
              template(v-if="indicator.y16")
                br
                | 2016: {{indicator.y16}}
          +e.overflow

      +e.legend
        +e.legend-cell(v-for="i in 9" v-bind:style="bgColor((i - 5) * 10)")
          +e.legend-label {{(i - 5) * 10}}
</template>

<script>
import { mapGetters } from 'vuex';
import d3 from '@/tools/d3/d3';

import TSection from '@/components/TSection/TSection';
import TH2 from '@/components/TH2/TH2';
import TH3 from '@/components/TH3/TH3';
import TSort from '@/components/TSort/TSort';

export default {
  name: 'the-table-section',

  data() {
    return {
      sorting: 0,
      decrise: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ],
    };
  },

  computed: {
    displayedData() {
      let sorted;
      const dataSet = this.dataSet.slice();
      switch (this.sorting) {
        case 1:
          sorted = this.decrise[1] ? dataSet.sort((a, b) => a.CPIScore.y18 - b.CPIScore.y18) : dataSet.sort((a, b) => b.CPIScore.y18 - a.CPIScore.y18);
          break;
        case 2:
          sorted = this.decrise[2] ? dataSet.sort((a, b) => a.indicators[0].y18 - b.indicators[0].y18) : dataSet.sort((a, b) => b.indicators[0].y18 - a.indicators[0].y18);
          break;
        case 3:
          sorted = this.decrise[3] ? dataSet.sort((a, b) => a.indicators[1].y18 - b.indicators[1].y18) : dataSet.sort((a, b) => b.indicators[1].y18 - a.indicators[1].y18);
          break;
        case 4:
          sorted = this.decrise[4] ? dataSet.sort((a, b) => a.indicators[2].y18 - b.indicators[2].y18) : dataSet.sort((a, b) => b.indicators[2].y18 - a.indicators[2].y18);
          break;
        case 5:
          sorted = this.decrise[5] ? dataSet.sort((a, b) => a.indicators[3].y18 - b.indicators[3].y18) : dataSet.sort((a, b) => b.indicators[3].y18 - a.indicators[3].y18);
          break;
        case 6:
          sorted = this.decrise[6] ? dataSet.sort((a, b) => a.indicators[4].y18 - b.indicators[4].y18) : dataSet.sort((a, b) => b.indicators[4].y18 - a.indicators[4].y18);
          break;
        case 7:
          sorted = this.decrise[7] ? dataSet.sort((a, b) => a.indicators[5].y18 - b.indicators[5].y18) : dataSet.sort((a, b) => b.indicators[5].y18 - a.indicators[5].y18);
          break;
        case 8:
          sorted = this.decrise[8] ? dataSet.sort((a, b) => a.indicators[6].y18 - b.indicators[6].y18) : dataSet.sort((a, b) => b.indicators[6].y18 - a.indicators[6].y18);
          break;
        case 9:
          sorted = this.decrise[9] ? dataSet.sort((a, b) => a.indicators[7].y18 - b.indicators[7].y18) : dataSet.sort((a, b) => b.indicators[7].y18 - a.indicators[7].y18);
          break;
        case 10:
          sorted = this.decrise[10] ? dataSet.sort((a, b) => a.indicators[8].y18 - b.indicators[8].y18) : dataSet.sort((a, b) => b.indicators[8].y18 - a.indicators[8].y18);
          break;
        case 11:
          sorted = this.decrise[11] ? dataSet.sort((a, b) => a.indicators[9].y18 - b.indicators[9].y18) : dataSet.sort((a, b) => b.indicators[9].y18 - a.indicators[9].y18);
          break;
        case 12:
          sorted = this.decrise[12] ? dataSet.sort((a, b) => a.indicators[10].y18 - b.indicators[10].y18) : dataSet.sort((a, b) => b.indicators[10].y18 - a.indicators[10].y18);
          break;
        case 13:
          sorted = this.decrise[13] ? dataSet.sort((a, b) => a.indicators[11].y18 - b.indicators[11].y18) : dataSet.sort((a, b) => b.indicators[11].y18 - a.indicators[11].y18);
          break;
        case 14:
          sorted = this.decrise[14] ? dataSet.sort((a, b) => a.indicators[12].y18 - b.indicators[12].y18) : dataSet.sort((a, b) => b.indicators[12].y18 - a.indicators[12].y18);
          break;
        default:
          sorted = this.decrise[0] ? dataSet.sort((a, b) => a.CPIScore.y18 - b.CPIScore.y18) : dataSet.sort((a, b) => b.CPIScore.y18 - a.CPIScore.y18);
          break;
      }
      return sorted;
    },

    change() {
      let result = true;
      for (let i = 0; i < this.decrise; i += 1) {
        result = !result;
      }
      return result;
    },

    ...mapGetters({
      dataSet: 'allDataSet',
      content: 'getContent',
      lng: 'lng',
    }),
  },

  methods: {
    bgColor(x) {
      const colorScale = d3.scaleLinear()
        .domain([-40, -20, -10, -5, 0, 5, 10, 20, 40])
        .range(['#a41d29', '#d73127', '#f36d44', '#fdf8c1', '#fdf8c1', '#d8e58d', '#a6d16a', '#66be64', '#25b34b']);

      return {
        backgroundColor: x || x === 0 ? colorScale(x) : '#e0e0e0',
      };
    },

    handleSort(i) {
      this.sorting = i;
      this.$set(this.decrise, i, !this.decrise[i]);
    },
  },

  components: {
    TSection,
    TH2,
    TH3,
    TSort,
  },
};
</script>


<style lang="scss">
@import '../../scss/styles';

.the-table-section {

  $country-width: 200px;
  $padding: 12px;
  $colomn-width: calc(((100% - #{$country-width}) / 15) - (#{$padding} * 2));

  position: relative;
  width: 100%;
  overflow: auto;

  &__table {
    position: relative;
    color: $black;
    font-size: 12px;
    font-family: $hfont;
    margin-top: 64px;
    margin-bottom: 40px;
  }

  &__row {
    position: relative;
    display: flex;
    background-color: $color-white;

    &_first {
      background-color: #efefef;
    }
  }

  &__name {
    color: $black;
    text-align: left;
    font-family: $hfont;
    font-size: 12px;
    width: calc(#{$country-width} - (#{$padding} * 2));
    padding: 6px $padding;
  }

  &__row_first &__name {
    text-align: center;
  }

  &__rank {
    position: relative;
    padding: 6px $padding;
    text-align: center;
    width: $colomn-width;
  }

  &__row_first &__rank {
    text-align: center;
  }

  &__row_titles {
    position: relative;
  }

  &__row_titles div:nth-child(even) {
    background-color: rgba(0,0,0,0.05);
  }

  &__vert {
    writing-mode: tb-rl;
    transform: rotate(-180deg);
    text-align: left;
    height: 150px;
  }

  &__score {
    position: relative;
    padding: 6px  $padding;
    text-align: center;
    width: $colomn-width;
    font-weight:400;
  }

  &__row_first &__score {
    text-align: center;
  }

  &__index {
    font-size: 8px;
    margin-bottom: 10px;
    font-weight: 600;
    padding-left: 2px;

    &_green {
      color: green;
    }

    &_red {
      color: red;
    }
  }

  &__col {
    position: relative;
    padding: 6px  $padding;
    text-align: center;
    width: $colomn-width;
  }

  &__row_first &__col {
    text-align: center;
  }

  &__overflow {
    position: absolute;
    opacity: 0;
    z-index: 100;
    transition: all 0.3;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: black;
    pointer-events: none;
  }

  &__row:hover &__overflow {
    opacity: 0.1;
    border: 1px solid $color-blue;
  }

  &__popup {
    display: none;
    position: absolute;
    padding: 8px;
    width: 100px;
    font-size: 10px;
    // transform: translate($colomn-width, 0);
    z-index: 1000000;

    &_right {
      top: 0;
      left: 0;
      margin-left: 100%;
      margin-top: 26px;
      border-radius: 0px 5px 5px 5px;
    }

    &_left {
      border-radius: 5px 0px 5px 5px;
      top: 0;
      right: 0;
      margin-right: 100%;
      margin-top: 26px;
    }
  }

  &__rank:hover &__popup,
  &__score:hover &__popup,
  &__col:hover &__popup {
    display: inline-block;
    background-color: #eee;
  }

  // BEGIN: Legend
  $legend-cell-size: 10px;

  &__legend {
    display: flex;
  }

  &__legend-cell {
    position: relative;
    width: 4 * $legend-cell-size;
    height: $legend-cell-size;
  }

  &__legend-label {
    position: absolute;
    top: $legend-cell-size;
    left: 0;
    color: #fff;
    font-size: 10px;
  }
  // END: Legend
}
</style>



// WEBPACK FOOTER //
// src/components/TheTableSection/TheTableSection.vue